import React, { useState } from 'react';
import { TileLayout, TileLayoutItem, TilePosition } from '@progress/kendo-react-layout';
import { HelpCenterDocument } from './HelpCenterDocument';
import { GenericSettingsMenu } from '../GenericSettingsMenu';
import { useGlobalizationContext, useTranslation, useUiAdminConfigsContext } from '@cs-cms/state-management';
import { CpsHelpCenterItemState, CpsHelpCenterState, CpsReportIssueState } from '@cs-cms/types';
import { HELP_CENTER_MENU_ITEM_TYPE } from '../../types/HelpCenterMenuItemType';

const positions: TilePosition[] = [
  {
    col: 1,
    colSpan: 1
  },
  {
    col: 2,
    colSpan: 1
  }
];

export const HelpCenterManagement: React.FC = () => {
  const { selectedLocale } = useGlobalizationContext();
  const { translate } = useTranslation(selectedLocale);
  const { uiAdminConfigState } = useUiAdminConfigsContext();
  const [manuallySelectedMenuItem, setManuallySelectedMenuItem] = useState<CpsHelpCenterItemState>();

  const helpCenterItems = (uiAdminConfigState.helpCenter as CpsHelpCenterState)?.items?.filter(
    item => !item.openAccess
  );

  const reportIssueItem: CpsHelpCenterItemState = {
    id: HELP_CENTER_MENU_ITEM_TYPE.RAPORT_ISSUE,
    name: translate('custom.settings.helpCenter.reportIssue.title')
  };

  const isReportIssueEnabled = (uiAdminConfigState.reportIssue as CpsReportIssueState)?.enabled === true;

  const menu: CpsHelpCenterItemState[] = !helpCenterItems
    ? isReportIssueEnabled
      ? [reportIssueItem]
      : []
    : isReportIssueEnabled
      ? helpCenterItems.concat(reportIssueItem)
      : helpCenterItems;

  const selectedMenuItem =
    menu.length === 0
      ? undefined
      : manuallySelectedMenuItem && menu.find(item => item.id === manuallySelectedMenuItem.id)
        ? manuallySelectedMenuItem
        : menu[0];

  const tiles: TileLayoutItem[] = [
    {
      body: (
        <GenericSettingsMenu<CpsHelpCenterItemState>
          menu={menu}
          value={selectedMenuItem}
          onSelectedMenuItemChanged={(value?: CpsHelpCenterItemState) => setManuallySelectedMenuItem(value)}
          textField="name"
          valueField="id"
        />
      ),
      className: 'helpCenterTileLayoutItem',
      reorderable: false,
      resizable: false
    },
    {
      body: <HelpCenterDocument selectedMenuItem={selectedMenuItem} />,
      className: 'helpCenterTileLayoutItem',
      reorderable: false,
      resizable: false
    }
  ];
  return (
    <div className="helpCenter">
      <TileLayout columns={2} positions={positions} items={tiles} />
    </div>
  );
};
